import { getAssignmentsByCourseId } from './getAssignmentsByCourseId'

/** @deprecated - use getAssignmentsByCourseId instead */
export async function getAssignments(courseId, callback = async () => {}) {
  return await getAssignmentsByCourseId(courseId, callback)
}
